var map = {
	"./Contact-C4.svg": [
		74931,
		4931
	],
	"./Contact-CG.svg": [
		59280,
		9280
	],
	"./Contact-Q5.svg": [
		69480,
		9480
	],
	"./Contact-XC.svg": [
		39185,
		9185
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 82049;
module.exports = webpackAsyncContext;